<template>
    <div>
        <div class="plain-card">
            <h5>
                <span @click.prevent="toggleFilters($event)" class="pointer">
                    <i class="fa fa-caret-down pull-left active pen-pink"></i>
                    {{ show_filters ? uLang('app.hide_filters') : uLang('app.show_filters') }}
                </span>
            </h5>

            <template v-if="show_filters">

                <!-- Trajectory types and projects -->
                <div class="row form-group">
                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.projects') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedProjects"
                                :options="availableFilterOptions.projects"
                                :placeholder="uLang('app.projects')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="2"
                                :limit-text="limitText('projects')"
                                id="projects"
                                name="projects"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectProject"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionProject()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.projects.length"
                                         @click="clearFilter('projects', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.trajectory_types') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedTrajectoryTypes"
                                :options="availableFilterOptions.trajectory_types"
                                :placeholder="uLang('app.trajectory_types')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="3"
                                :limit-text="limitText('trajectory_types')"
                                id="trajectory_types"
                                name="trajectory_types"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectTrajectoryType"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionTrajectoryType()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.trajectory_types.length"
                                         @click="clearFilter('trajectory_types', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>
                </div>

                <!-- Trajectories and clients -->
                <div class="row form-group">
                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.clients') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedClients"
                                :options="availableFilterOptions.clients"
                                :placeholder="uLang('app.clients')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="3"
                                :limit-text="limitText('clients')"
                                id="clients"
                                name="clients"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectClient"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionClient()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.clients.length"
                                         @click="clearFilter('clients', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.trajectories') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedTrajectories"
                                :options="availableFilterOptions.trajectories"
                                :placeholder="uLang('app.trajectories')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="2"
                                :limit-text="limitText('trajectories')"
                                id="trajectories"
                                name="trajectories"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectTrajectory"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionTrajectory()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.trajectories.length"
                                         @click="clearFilter('trajectories', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>
                </div>

                <!-- Regions and coachServices -->
                <div class="row form-group">
                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.regions') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedRegions"
                                :options="availableFilterOptions.regions"
                                :placeholder="uLang('app.regions')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="3"
                                :limit-text="limitText('regions')"
                                id="regions"
                                name="regions"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectRegion"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionRegion()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.regions.length"
                                         @click="clearFilter('regions', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.coach_services') }}</label>
                        <div class="col-md-9 col-xl-10 col-sm-12">
                            <multi-select
                                v-model="selectedCoachServices"
                                :options="availableFilterOptions.coach_services"
                                :placeholder="uLang('app.coach_services')"
                                :close-on-select="false"
                                :show-labels="false"
                                @input="updateData()"
                                :limit="3"
                                :limit-text="limitText('coach_services')"
                                id="coach_services"
                                name="coach_services"
                                track-by="id"
                                label="name"
                                return="id"
                                multiple
                                ref="multiSelectCoachService"
                            >
                                <template slot="tag" slot-scope="props">
                                    <span class="multiselect__tag" :title="props.option && props.option.name">
                                        <span>{{ props.option && props.option.name }}</span>
                                        <i class="multiselect__tag-icon" aria-hidden="true" @mousedown.prevent="props.remove(props.option)"></i>
                                    </span>
                                </template>
                                <template slot="beforeList">
                                    <li class="multiselect__element multiselect__element__idplein" @click.prevent.stop="handleCustomOptionCoachService()"><span class="multiselect__option"><span>Selecteer alles</span></span></li>
                                </template>
                                <template slot="clear" slot-scope="props">
                                    <div v-show="filters.coach_services.length"
                                         @click="clearFilter('coach_services', [])"
                                         class="multiselect__clear"
                                    ></div>
                                </template>
                            </multi-select>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="plain-card-2">
            <scrollable-second :loading="loading">
                <template slot="header">
                    <tr>
                        <th class="icon-sort-header" @click="sortTable('full_name')">{{ uLang('app.report_coach') }} ({{ num_all_coach }}) 
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'full_name' && sortOrder === 'asc', '-descending': sortColumn === 'full_name' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_region_name')">{{ uLang('app.report_region') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_region_name' && sortOrder === 'asc', '-descending': sortColumn === 'text_region_name' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_max_trajectories')">{{ uLang('app.report_coach_capacity_max_trajectories') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_max_trajectories' && sortOrder === 'asc', '-descending': sortColumn === 'text_max_trajectories' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_coach_capacity')">{{ uLang('app.report_coach_capacity_coach_capacity') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_coach_capacity' && sortOrder === 'asc', '-descending': sortColumn === 'text_coach_capacity' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_avaliable')">{{ uLang('app.report_coach_capacity_avaliable') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_avaliable' && sortOrder === 'asc', '-descending': sortColumn === 'text_avaliable' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_unavailable_period_start')">{{ uLang('app.report_coach_unavailable_period_start') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_unavailable_period_start' && sortOrder === 'asc', '-descending': sortColumn === 'text_unavailable_period_start' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_unavailable_period_end')">{{ uLang('app.report_coach_unavailable_period_end') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_unavailable_period_end' && sortOrder === 'asc', '-descending': sortColumn === 'text_unavailable_period_end' && sortOrder === 'desc'}"></span>
                        </th>
                        <th class="icon-sort-header" @click="sortTable('text_overdue_count')">{{ uLang('app.report_overdue_count') }}
                            <span class="icon-sort" :class="{'-ascending': sortColumn === 'text_overdue_count' && sortOrder === 'asc', '-descending': sortColumn === 'text_overdue_count' && sortOrder === 'desc'}"></span>
                        </th>
                    </tr>
                    <tr class="summary-1">
                        <th>{{ uLang('app.average') }}</th>
                        <th></th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1
                            }).format(average_max_trajectories) }}</th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1
                            }).format(average_coach_capacity) }}</th>
                        <th>{{getTextInPercent(average_avaliable)}}</th>
                        <th></th>
                        <th></th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1
                            }).format(average_overdue) }}</th>
                    </tr>
                    <tr class="summary-2">
                        <th>{{ uLang('app.total') }}</th>
                        <th></th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }).format(total_max_trajectories) }}</th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }).format(total_coach_capacity) }}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>{{ Intl.NumberFormat('de-DE', {
                                style: 'decimal',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }).format(total_overdue) }}</th>
                    </tr>
                </template>
                <tbody slot="body">
                    <tr v-for="coach in coachs" :key="coach.id">
                        <td>
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                <a :href="'/admin/relations/'+ coach.id" target="_blank">{{ coach.full_name }}</a>
                            </template>
                            <template v-else>
                                {{ coach.full_name }}
                            </template>
                        </td>
                        <td>{{ coach.text_region_name }}</td>
                        <td>
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                {{ coach.text_max_trajectories ?? '-' }} <a href="#" @click.prevent="editCoach(coach)"><i class="fa fa-edit pointer"></i></a>
                            </template>
                            <template v-else>
                                {{ coach.text_max_trajectories ?? '-' }}
                            </template>
                        </td>
                        <td>
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                <a href="#" @click.prevent="loadModalCoachCapacity(coach)" target="_blank">{{ coach.text_coach_capacity }}</a>
                            </template>
                            <template v-else>
                                {{ coach.text_coach_capacity }}
                            </template>
                        </td>
                        <td>{{ getTextInPercent(coach.text_avaliable) }}</td>
                        <td>
                            {{ coach.text_unavailable_period_start }}
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                <a href="#" @click.prevent="editPeriodStart(coach)"><i class="fa fa-edit pointer"></i></a>
                            </template>
                        </td>
                        <td>
                            {{ coach.text_unavailable_period_end }}
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                <a href="#" @click.prevent="editPeriodEnd(coach)"><i class="fa fa-edit pointer"></i></a>
                            </template>
                        </td>
                        <td>
                            <template v-if="authUser.type_id === 5 || authUser.id === coach.id">
                                <a href="#" @click.prevent="showCoachOverdue(coach)" target="_blank">{{ coach.text_overdue_count }}</a>
                            </template>
                            <template v-else>
                                {{ coach.text_overdue_count }}
                            </template>
                        </td>
                    </tr>
                </tbody>
            </scrollable-second>

            <div v-if="isShowingModalEditPeriodEnd" class="modal fade show  d-flex align-items-center justify-content-center d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">{{ uLang('app.report_coach_unavailable_period_end') }} aanpassen</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalPeriodEnd">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <p style="font-size:20px;color:#c1006d;margin-bottom:2px">{{ selectedCoach.full_name }}</p>
                                    {{ uLang('app.report_coach_unavailable_period_end') }}: * 
                                    <vue-pikaday
                                        v-model="selectedDateTextInPikaday"
                                        :options="pikadayOptions" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="saveChangesPeriodEnd">{{ uLang('app.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isShowingModalEditPeriodStart" class="modal fade show  d-flex align-items-center justify-content-center d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">{{ uLang('app.report_coach_unavailable_period_start') }} aanpassen</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalPeriodStart">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <p style="font-size:20px;color:#c1006d;margin-bottom:2px">{{ selectedCoach.full_name }}</p>
                                    {{ uLang('app.report_coach_unavailable_period_start') }}: * 
                                    <vue-pikaday
                                        v-model="selectedDateTextInPikaday"
                                        :options="pikadayOptions" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="saveChangesPeriodStart">{{ uLang('app.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isShowingModalEditCoachMaxTrajectory" class="modal fade show  d-flex align-items-center justify-content-center d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">{{ uLang('app.report_coach_capacity_max_trajectories') }} aanpassen</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalCoachMaxTrajectory">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <p style="font-size:20px;color:#c1006d;margin-bottom:2px">{{ selectedCoach.full_name }}</p>
                                    {{ uLang('app.report_coach_capacity_max_trajectories') }}: * <input type="number" v-model="selectedCoach.text_max_trajectories" min="0" style="margin-left:20px;"/>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="saveChangesCoachMaxTrajectory">{{ uLang('app.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isShowingModalOverdue" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">{{ uLang('app.overview_trajectory_enrolments') }}</h5>
                        </div>
                        <div class="modal-body" style="max-height: 500px; overflow-y: auto;">
                            <div class="row">
                                <div class="col-12">
                                    <table class="customer-following-system-table table mt-4">
                                        <tr>
                                            <!-- <th>ID</th> -->
                                            <th>{{ uLang('app.customer') }}</th>
                                            <th>{{ uLang('app.trajectory') }}</th>
                                            <th>{{ uLang('app.next_action') }}</th>
                                            <th>{{ uLang('app.end_date') }}</th>
                                            <th>{{ uLang('app.snooze_date') }}</th>
                                        </tr>
                                        <tr v-for="trajectoryEnrolment in selectedDataOverdue.my_customer_management_info_result">
                                            <!-- <td>
                                                {{ trajectoryEnrolment.id }}
                                            </td> -->
                                            <td>
                                                <a :href="'/admin/relations/' + trajectoryEnrolment.candidate_id">{{ trajectoryEnrolment.candidate_first_name }} {{ trajectoryEnrolment.candidate_last_name }}</a>
                                            </td>
                                            <td>
                                                <a :href="`/admin/relations/${trajectoryEnrolment.candidate_id}/trajectory-enrolments/${trajectoryEnrolment.id}/milestone-progresses/${trajectoryEnrolment.my_project_milestone_progress_id}`">
                                                    {{ trajectoryEnrolment.trajectory_name }}
                                                </a>
                                            </td>
                                            <td>
                                                <a :href="`/admin/relations/${trajectoryEnrolment.candidate_id}/trajectory-enrolments/${trajectoryEnrolment.id}/milestone-progresses/${trajectoryEnrolment.my_project_milestone_progress_id}/action-progresses/${trajectoryEnrolment.my_project_action_progresses_id}/action-document`">
                                                    {{ trajectoryEnrolment.my_project_action_name }}
                                                </a>
                                            </td>
                                            <td>
                                                {{ trajectoryEnrolment.my_project_due_date | date }}
                                            </td>
                                            <td>
                                                {{ trajectoryEnrolment.longest_snooze_date | date }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="isShowingModalOverdue = false">{{ uLang('app.close') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isShowingModalCoachCapacity" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
                <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">{{ uLang('app.overview_trajectory_enrolments') }}</h5>
                        </div>
                        <div class="modal-body" style="max-height: 500px; overflow-y: auto;">
                            <div class="row">
                                <div class="col-12 enrolment" v-if="enrolments.length > 0" v-for="enrolment in enrolments" :key="enrolment.id">
                                    <router-link :to="{
                                            name: 'admin.relations.trajectory-enrolments.view',
                                            params: {
                                                'relationId': enrolment.candidate_id,
                                                'trajectoryEnrolmentId': enrolment.id,
                                            }
                                        }"
                                    >
                                        <h5 style="color: black;">{{ $getIfExists(enrolment, 'trajectory_name') }}</h5>
                                    </router-link>

                                    <span class="enrolment-info" :title="uLang('app.candidate')">
                                        <i class="fa fa-lg fa-user"></i>
                                        <link-if-permissions
                                            :to="{ name: 'admin.relations.view', params: { id: enrolment.candidate_id }}"
                                            permissions="view-relations"
                                        >
                                            <span class="text-brand">
                                                {{ getCandidateName(enrolment) }}
                                            </span>
                                        </link-if-permissions>
                                    </span>
                                </div>
                                <div class="col-12" v-if="!enrolments || enrolments.length === 0">
                                    {{ uLang('app.no_enrolments') }}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="isShowingModalCoachCapacity = false">{{ uLang('app.close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    import { TrajectoryManagerSelect } from '~/Form/elements';
    import { ReaLoader } from "~/components/helpers";
    import { mapGetters } from 'vuex'
    import ManagementInfoResultRow from "~/components/tables/table-rows/ManagementInfoResultRow"
    import { ToggleFiltersMixin } from '~/mixins/management-info'
    import SettingSelect from "../../../Form/elements/setting-select"
    import { debounce } from 'lodash'
    import ScrollableSecond from '~/components/tables/templates/scrollablesecond'
    import { SuccessAlert } from '~/Swals'

    export default {
        name: 'results_new',
        components: {
            SettingSelect,
            ManagementInfoResultRow,
            ReaLoader,
            MultiSelect,
            TrajectoryManagerSelect,
            ScrollableSecond
        },
        mixins: [ToggleFiltersMixin],
        watch: {
            sortColumn() {
                this.sortData();
            },
            sortOrder() {
                this.sortData();
            },
        },
        data() {
            return {
                show_filters: true,
                loading: true,
                loadingFilters: false,
                coachs: [],
                selected_date_preset: null,
                date_filter_presets: {
                    all: {
                        months: null,
                        name: this.uLang('app.all_results')
                    },
                    three: {
                        months: 3,
                        name: `${ this.uLang('app.current_calendar_year')}`,
                    },
                    six: {
                        months: 6,
                        name: `${ this.uLang('app.previous_calendar_year')}`,
                    },
                    twelve: {
                        months: 12,
                        name: `12 ${ this.uLang('app.months') }`,
                    },
                    custom: {
                        months: null,
                        name: this.uLang('app.custom_input'),
                    },
                },
                filters: {
                    date_from: null,
                    date_to: null,
                    trajectory_types: [],
                    projects: [],
                    trajectories: [],
                    coach_services: [],
                    clients: [],
                    regions: [],
                    collaboration_statuses: {
                        active: true,
                        ended: false
                    }
                },
                availableFilterOptions: {
                    trajectory_types: [],
                    projects: [],
                    trajectories: [],
                    clients: [],
                    regions: [],
                    coach_services: [],
                },
                num_all_coach: 0,

                total_max_trajectories: 0,
                total_coach_capacity: 0,
                total_overdue: 0,

                average_max_trajectories: 0,
                average_coach_capacity: 0,
                average_avaliable: 0,
                average_overdue: 0,

                sortColumn: 'text_region_name',
                sortOrder: 'asc',

                isShowingModalEditCoachMaxTrajectory: false,
                isShowingModalEditPeriodEnd: false,
                isShowingModalEditPeriodStart: false,
                isShowingModalOverdue: false,

                isShowingModalCoachCapacity: false,
                enrolments: [],

                selectedCoach: null,
                selectedDataOverdue: null,

                selectedDateTextInPikaday: null,
                pikadayOptions: {
                    format: 'DD-MM-YYYY',
                    minDate: moment().add(1, 'days').toDate(),
                }
            }
        },
        async created() {
            this.getTrajectoryTypes()
            this.defaultFilters()
        },
        computed: {
            ...mapGetters(['authUser', 'settingByName']),
            selectedTrajectoryTypes: {
                get() {
                    return this.selectedEntityGetter('trajectory_types')
                },
                set(trajectory_types) {
                    this.selectedEntitySetter(trajectory_types, 'trajectory_types')
                }
            },
            selectedProjects: {
                get() {
                    return this.selectedEntityGetter('projects')
                },
                set(projects) {
                    this.selectedEntitySetter(projects, 'projects')
                }
            },
            selectedTrajectories: {
                get() {
                    return this.selectedEntityGetter('trajectories')
                },
                set(trajectories) {
                    this.selectedEntitySetter(trajectories, 'trajectories')
                }
            },
            selectedClients: {
                get() {
                    return this.selectedEntityGetter('clients')
                },
                set(clients) {
                    this.selectedEntitySetter(clients, 'clients')
                }
            },
            selectedRegions: {
                get() {
                    return this.selectedEntityGetter('regions')
                },
                set(regions) {
                    this.selectedEntitySetter(regions, 'regions')
                }
            },
            selectedCoachServices: {
                get() {
                    return this.selectedEntityGetter('coach_services')
                },
                set(coach_services) {
                    this.selectedEntitySetter(coach_services, 'coach_services')
                }
            },
            

        },
        methods: {
            handleCustomOptionProject() {
                this.filters.projects = this.availableFilterOptions.projects.map(p => p.id);
                this.$refs.multiSelectProject.deactivate();
                this.updateData();
            },
            handleCustomOptionTrajectory() {
                this.filters.trajectories = this.availableFilterOptions.trajectories.map(p => p.id);
                this.$refs.multiSelectTrajectory.deactivate();
                this.updateData();
            },
            handleCustomOptionClient() {
                this.filters.clients = this.availableFilterOptions.clients.map(p => p.id);
                this.$refs.multiSelectClient.deactivate();
                this.updateData(true);
            },
            handleCustomOptionRegion() {
                this.filters.regions = this.availableFilterOptions.regions.map(p => p.id);
                this.$refs.multiSelectRegion.deactivate();
                this.updateData(true);
            },
            handleCustomOptionTrajectoryType() {
                this.filters.trajectory_types = this.availableFilterOptions.trajectory_types.map(p => p.id);
                this.$refs.multiSelectTrajectoryType.deactivate();
                this.updateData(true);
            },
            handleCustomOptionCoachService() {
                this.filters.coach_services = this.availableFilterOptions.coach_services.map(p => p.id);
                this.$refs.multiSelectCoachService.deactivate();
                this.updateData(true);
            },
            showCoachOverdue (coach) {
                this.isShowingModalOverdue = true;
                this.selectedDataOverdue = { ...coach };
            },
            editPeriodEnd(coach) {
                this.selectedCoach = { ...coach };
                const [day, month, year] = coach.text_unavailable_period_end.split('-');
                this.selectedDateTextInPikaday = new Date(`${year}-${month}-${day}`);
                this.isShowingModalEditPeriodEnd = true;
            },
            editPeriodStart(coach) {
                this.selectedCoach = { ...coach };
                const [day, month, year] = coach.text_unavailable_period_start.split('-');
                this.selectedDateTextInPikaday = new Date(`${year}-${month}-${day}`);
                this.isShowingModalEditPeriodStart = true;
            },
            editCoach(coach) {
                this.selectedCoach = { ...coach };
                this.isShowingModalEditCoachMaxTrajectory = true;
            },
            loadModalCoachCapacity(coach) {
                this.isShowingModalCoachCapacity = true;
                this.enrolments = coach.management_info_results_all.filter(item => 
                    [2].includes(item.status_id)
                );
            },
            getCandidateName(enrolment) {
                const first_letters = $getIfExists(enrolment, 'candidate_first_letters')
                const first_name = $getIfExists(enrolment, 'candidate_first_name')
                const prefix = $getIfExists(enrolment, 'candidate_prefix')
                const last_name = $getIfExists(enrolment, 'candidate_last_name')

                return `${ (first_name || first_letters || '') } ${ (prefix || '') } ${ last_name }`
            },
            async saveChangesCoachMaxTrajectory() {
                try {
                    
                    if (this.selectedCoach.text_max_trajectories !== "") {
                        const new_max_trajectory = Number.parseInt(this.selectedCoach.text_max_trajectories, 10);

                        const { data } = await window.axios.put(route('management-info.results-coach-capacity-update-coach-max-trajectories', {
                            id: this.selectedCoach.id
                        }), {
                            new_max_trajectory: new_max_trajectory
                        });

                        const coach = this.coachs.find(coach => coach.id === this.selectedCoach.id);
                        if (coach) {
                            coach.text_max_trajectories = new_max_trajectory;
                        }

                        new SuccessAlert({
                            text: data.message
                        }).show();

                        this.closeModalCoachMaxTrajectory();

                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                } catch (error) {
                    console.error("Error updating coach:", error);
                }
            },
            async saveChangesPeriodEnd() {
                try {
                    let selectDateString = "";
                    if (this.selectedDateTextInPikaday == null) { // Covers both null and undefined
                        selectDateString = "";
                    } else if (typeof this.selectedDateTextInPikaday === "string") {
                        if (this.selectedDateTextInPikaday === "-") {
                            selectDateString = "";
                        } else {
                            selectDateString = this.selectedDateTextInPikaday;
                        }
                    } else if (this.selectedDateTextInPikaday instanceof Date) {
                        const yyyy = this.selectedDateTextInPikaday.getFullYear();
                        const mm = String(this.selectedDateTextInPikaday.getMonth() + 1).padStart(2, '0'); // Month is 0-based
                        const dd = String(this.selectedDateTextInPikaday.getDate()).padStart(2, '0');

                        selectDateString = `${dd}-${mm}-${yyyy}`;
                    }

                    try {
                        const { data } = await window.axios.put(route('management-info.results-coach-capacity-update-period-end', {
                            id: this.selectedCoach.id
                        }), {
                            selectDateString
                        });

                        const coach = this.coachs.find(coach => coach.id === this.selectedCoach.id);
                        if (coach) {
                            if (selectDateString !== "") {
                                coach.text_unavailable_period_end = selectDateString;
                            } else {
                                coach.text_unavailable_period_end = "-";
                            }
                        }

                        new SuccessAlert({
                            text: data.message
                        }).show();
                        this.closeModalPeriodEnd();
                    } catch (error) {
                        console.error("Error updating coach:", error);
                    }
                    this.closeModalPeriodEnd();
                } catch (error) {
                    console.error("Error updating coach:", error);
                }
            },

            async saveChangesPeriodStart() {
                try {
                    let selectDateString = "";
                    if (this.selectedDateTextInPikaday == null) { // Covers both null and undefined
                        selectDateString = "";
                    } else if (typeof this.selectedDateTextInPikaday === "string") {
                        if (this.selectedDateTextInPikaday === "-") {
                            selectDateString = "";
                        } else {
                            selectDateString = this.selectedDateTextInPikaday;
                        }
                    } else if (this.selectedDateTextInPikaday instanceof Date) {
                        const yyyy = this.selectedDateTextInPikaday.getFullYear();
                        const mm = String(this.selectedDateTextInPikaday.getMonth() + 1).padStart(2, '0'); // Month is 0-based
                        const dd = String(this.selectedDateTextInPikaday.getDate()).padStart(2, '0');

                        selectDateString = `${dd}-${mm}-${yyyy}`;
                    }

                    try {
                        const { data } = await window.axios.put(route('management-info.results-coach-capacity-update-period-start', {
                            id: this.selectedCoach.id
                        }), {
                            selectDateString
                        });

                        const coach = this.coachs.find(coach => coach.id === this.selectedCoach.id);
                        if (coach) {
                            if (selectDateString !== "") {
                                coach.text_unavailable_period_start = selectDateString;
                            } else {
                                coach.text_unavailable_period_start = "-";
                            }
                        }

                        new SuccessAlert({
                            text: data.message
                        }).show();
                        this.closeModalPeriodStart();
                    } catch (error) {
                        console.error("Error updating coach:", error);
                    }
                    this.closeModalPeriodStart();
                } catch (error) {
                    console.error("Error updating coach:", error);
                }
            },

            closeModalCoachMaxTrajectory() {
                this.isShowingModalEditCoachMaxTrajectory = false;
                this.selectedCoach = null;
            },
            closeModalPeriodEnd() {
                this.isShowingModalEditPeriodEnd = false;
                this.selectedCoach = null;
            },
            closeModalPeriodStart() {
                this.isShowingModalEditPeriodStart = false;
                this.selectedCoach = null;
            },
            sortData() {
                this.coachs = [...this.coachs].sort((a, b) => {
                    const valueA = a[this.sortColumn];
                    const valueB = b[this.sortColumn];

                    if (typeof valueA === 'string' && typeof valueB === 'string') {
                    return this.sortOrder === 'asc'
                        ? valueA.localeCompare(valueB)
                        : valueB.localeCompare(valueA);
                    }

                    if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
                    if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
                    return 0;
                });
            },
            filteredOverdueCount(managementInfo) {
                return managementInfo.filter(item => {
                    const currentDate = new Date();
                    const myProjectDueDate = new Date(item.my_project_due_date);
                    if (item.my_project_due_date != null && myProjectDueDate < currentDate) {
                        return item;
                    }
                }).length;
            },
            getTextInPercent(number) {
                if (typeof number === "number") {
                    return number.toFixed(0) + "%";
                } else {
                    return "N/A";
                }
            },
            defaultFilters() {
                if (localStorage.getItem("filtersSavedSelectedDatePresetCoachCapacity"))
                {
                    const preset = JSON.parse(localStorage.getItem("filtersSavedSelectedDatePresetCoachCapacity"));
                    this.applyDatePreset(this.date_filter_presets[preset]?.months, preset);
                }
                else
                {
                    this.applyDatePreset(3, 'three')
                }
                if (localStorage.getItem("filtersSavedCoachCapacity"))
                {
                    this.filters = JSON.parse(localStorage.getItem("filtersSavedCoachCapacity"));
                    this.filters.date_from = null;
                    this.filters.date_to = null;

                    if(this.filters.date_from === "1970-01-01T00:00:00.000Z") {
                        this.filters.date_from = null;
                    } else {
                        this.filters.date_from = new Date(this.filters.date_from);
                    }
                    if(this.filters.date_to === "1970-01-01T00:00:00.000Z") {
                        this.filters.date_to = null;
                    } else {
                        this.filters.date_to = new Date(this.filters.date_to);
                    }
                }
                else {
                    this.filters.date_from = null;
                    this.filters.date_to = null;
                }
                this.updateData(true)
            },
            limitText: (entity) => count => uLang('app.multiselect_overflow', {
                count,
                entity: lang(`app.${ entity }`).toLowerCase()
            }),
            selectedEntityGetter(entityName) {
                return this.filters[entityName].map(entityId => this.availableFilterOptions[entityName].find(entity => entity.id === entityId))
            },
            selectedEntitySetter(entity, entityName) {
                this.filters[entityName] = entity.map(entity => entity.id)
            },
            applyDatePreset(months, key) {
                this.selected_date_preset = key

                if (key === 'all') {
                    this.filters.date_from = null
                    this.filters.date_to = null
                }

                if (months === 3 || months === 6) {
                    if(months === 3 ) {
                        this.filters.date_from = moment().startOf('year').toDate();
                        this.filters.date_to = moment().endOf('year').toDate();
                    } else if(months === 6) {
                        this.filters.date_from = moment().subtract(1, 'year').startOf('year').toDate();
                        this.filters.date_to = moment().subtract(1, 'year').endOf('year').toDate();
                    }
                } else {
                    this.filters.date_from = months ? moment().subtract(months, 'months').toDate() : null;
                    this.filters.date_to = months ? moment().toDate() : null;
                }
                this.updateData()
            },
            filterCollaborationStatus(status) {
                this.filters.collaboration_statuses[status] = !this.filters.collaboration_statuses[status]
                this.updateData()
            },
            clearFilter(name, value = null) {
                this.filters[name] = value
                this.updateData()
            },
            async fetchData() {
                this.loading = true;

                if(this.filters.date_from === "1970-01-01T00:00:00.000Z" || this.filters.date_from?.toString() === (new Date(0)).toString()) {
                    this.filters.date_from = null;
                }
                if(this.filters.date_to === "1970-01-01T00:00:00.000Z" || this.filters.date_to?.toString() === (new Date(0)).toString()) {
                    this.filters.date_to = null;
                }

                let filters = JSON.stringify({
                    ...this.filters,
                    date_from: this.filters.date_from ? this.filters.date_from?.toDateString() ?? null : null,
                    date_to: this.filters.date_to ? this.filters.date_to?.toDateString() ?? null : null,
                })

                const { data } = await window.axios.get(route('management-info.results-coach-capacity', { filters }))
                this.coachs = data;

                this.coachs.map(coach => {
                    coach.text_region_name = coach.region_name ?? '-';
                    coach.text_max_trajectories = coach.max_trajectories;
                    coach.text_coach_capacity = coach.my_capacity_count;
                    if (coach.text_max_trajectories === null || coach.text_max_trajectories === 0) {
                        coach.text_avaliable = 'N/A';
                    } else {
                        coach.text_avaliable = (1.00 - (coach.text_coach_capacity / coach.text_max_trajectories)) * 100.00;
                    }

                    const currentDate = new Date();
                    const unavailablePeriodStart = new Date(coach.unavailable_period_start);
                    const unavailablePeriodEnd = new Date(coach.unavailable_period_end);

                    coach.text_unavailable_period_start = unavailablePeriodStart > currentDate 
                        ? coach.unavailable_period_start.substring(0, 10).split('-').reverse().join('-')
                        : '-';

                    coach.text_unavailable_period_end = unavailablePeriodEnd > currentDate 
                        ? coach.unavailable_period_end.substring(0, 10).split('-').reverse().join('-')
                        : '-';

                    coach.text_overdue_count = this.filteredOverdueCount(coach.my_customer_management_info_result);

                    return coach;
                })

                this.getAllStatistic(data);
                this.filterOnlyHasSuccessTrajectory();
                this.sortData();
                this.loading = false;
            },
            filterOnlyHasSuccessTrajectory() {
                if (this.filters.projects.length > 0 || this.filters.clients.length > 0) {
                    this.coachs = this.coachs.filter(coach => {
                        return coach.text_coach_capacity > 0;
                    });
                }
            },
            
            getAllStatistic(coachs) {
                let sum_max_trajectories = 0;
                let sum_coach_capacity = 0;
                let sum_avaliable = 0;
                let sum_overdue = 0;

                let num_all_coach = coachs.length;

                coachs.forEach(coach => {
                    sum_max_trajectories += coach.text_max_trajectories ?? 0;
                    sum_coach_capacity += coach.text_coach_capacity ?? 0;
                    sum_avaliable +=  (typeof coach.text_avaliable === "string" ) ? 0 : coach.text_avaliable;
                    sum_overdue +=  coach.text_overdue_count;
                });

                this.total_max_trajectories = sum_max_trajectories;
                this.total_coach_capacity = sum_coach_capacity;
                this.total_overdue = sum_overdue;
                
                this.num_all_coach = num_all_coach;

                if (this.num_all_coach !== 0) {
                    this.average_max_trajectories = (sum_max_trajectories / num_all_coach).toFixed(1);
                    this.average_coach_capacity = (sum_coach_capacity / num_all_coach).toFixed(1);
                    this.average_avaliable = (sum_avaliable / num_all_coach);
                    this.average_overdue = (sum_overdue / num_all_coach).toFixed(1);
                }
            },

            sortTable(column) {
                if (this.sortColumn === column) {
                    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortColumn = column;
                    this.sortOrder = 'asc';
                }
            },

            async getTrajectoryTypes() {
                const { data } = await window.axios.get(route('settings.values.index', { setting: 12 }))

                // "Without type" (id: null) = coaches with no enrolments; included in default selection.
                // Backend createCoachCapacity always keeps those coaches even if null is not in the filter.
                data.push({ id: null, value: this.uLang('app.trajectories_without_type'), system_name: null })

                const trajectory_type = data.reduce((result, type) => {
                    this.availableFilterOptions.trajectory_types.push({
                        id: type.id,
                        name: type.value,
                        system_name: type.system_name
                    })

                    if (type.system_name !== 'quotation_phase') {
                        result.push(type.id);
                    }

                    return result;
                }, []);

                if (!localStorage.getItem("filtersSavedCoachCapacity")) {
                    this.filters.trajectory_types = trajectory_type;
                }
            },
            updateData: debounce(function (test) {
                this.recalculateData(test)
            }, 300),

            async recalculateData() {
                this.loadingFilters = true

                if(this.filters.date_from === "1970-01-01T00:00:00.000Z" || this.filters.date_from?.toString() === (new Date(0)).toString()) {
                    this.filters.date_from = null;
                }
                if(this.filters.date_to === "1970-01-01T00:00:00.000Z" || this.filters.date_to?.toString() === (new Date(0)).toString()) {
                    this.filters.date_to = null;
                }

                // Prepare filters
                let filters = JSON.stringify({
                    ...this.filters,
                    date_from: this.filters.date_from ? this.filters.date_from?.toDateString() ?? null : null,
                    date_to: this.filters.date_to ? this.filters.date_to?.toDateString() ?? null : null,
                })

                const { data } = await window.axios.get(route('management-info.result-filters', { filters }))
                
                let { projects, trajectories, clients, regions, coach_services } = data;

                // Clear unavailable options from filters
                this.filters.projects = this.filters.projects.filter((el) => projects.map(p => p.id).includes(el));
                this.filters.trajectories = this.filters.trajectories.filter((el) => trajectories.map(p => p.id).includes(el));
                this.filters.clients = this.filters.clients.filter((el) => clients.map(p => p.id).includes(el));
                this.filters.regions = this.filters.regions.filter((el) => regions.map(p => p.id).includes(el));
                
                this.filters.coach_services = this.filters.coach_services ?? [];
                this.filters.coach_services = this.filters.coach_services.filter((el) => coach_services.map(p => p.id).includes(el));

                // Set available filter options
                this.availableFilterOptions.projects = projects
                this.availableFilterOptions.trajectories = trajectories
                this.availableFilterOptions.clients = clients
                this.availableFilterOptions.regions = regions
                this.availableFilterOptions.coach_services = coach_services

                this.loadingFilters = false

                localStorage.setItem("filtersSavedCoachCapacity", JSON.stringify(this.filters));
                localStorage.setItem("filtersSavedSelectedDatePresetCoachCapacity", JSON.stringify(this.selected_date_preset));
                await this.fetchData()
            },
        }
    }
</script>

<style lang="scss" scoped>
    .multiselect__element__idplein{
        background-color: #ffe9f6;
    }
    .multiselect__element__idplein:hover{
        color:white;
        background-color: #c1006d;
        font-weight: bold;
    }

    ::v-deep .multiselect__content-wrapper {
        width: max-content;
        min-width: 100%;
        max-width: 720px;
        overflow-x: auto;
    }

    ::v-deep .multiselect__content {
        min-width: 100%;
        width: max-content;
    }

    ::v-deep .multiselect__option {
        white-space: nowrap;
    }

    ::v-deep .multiselect__option::after {
        display: none;
        content: none;
    }

    .plain-card ::v-deep .multiselect__tags {
        height: 35px !important;
        overflow: hidden;
        line-height: 35px;
    }

    .plain-card ::v-deep .multiselect__tag {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
    }

    .plain-card ::v-deep .multiselect__tag > span {
        display: inline-block;
        max-width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
    }
    .pressed {
        background-color: #c1006d;
        font-weight: bold;
        text-decoration: underline;
    }
    .datePresetButton {
        border: 1px solid white;
    }
    .fa-caret-down {
        transition: transform .3s ease;

        &.active {
            -webkit-transform: rotate(-180deg);
            -moz-transform: rotate(-180deg);
            -o-transform: rotate(-180deg);
            -ms-transform: rotate(-180deg);
            transform: rotate(-180deg);
        }
    }

    .plain-card {
        background-color: white;
        padding: 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;
        &:not(:first-child) {
            margin-top: 30px;
        }
        h2 {
            margin-bottom: 20px;
        }
        table {
            width: 100%;
            td, th {
                padding: 6px;
                text-align: left;
            }
            .divider {
                width: 1%;
                border: none;
            }
            .result {
                width: 6%;
            }
        }
    }

    .plain-card-2 {
        background-color: white;
        padding: 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;
        table {
            th.icon-sort-header {
                padding-right: 14px;
                cursor: pointer;
            }
            th:nth-child(1), th:nth-child(2) {
                text-align: left;
            }
            th:nth-child(3), th:nth-child(4), th:nth-child(5), th:nth-child(8) {
                text-align: center;
            }
            th:nth-child(6), th:nth-child(7) {
                text-align: left;
            }
            tbody {
                td:nth-child(1), td:nth-child(2) {
                    text-align: left;
                }
                td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(8) {
                    text-align: center;
                }
                td:nth-child(6), td:nth-child(7) {
                    text-align: left;
                }

                tr > td > i {
                    display: inline;
                    width: 0;
                    color: #c1006d;
                }
            }
        }
    }
    span.sorting-symbol-report-coach {
        color: #c1006d;
    }
    .multiselect__clear {
        position: absolute;
        right: 41px;
        height: 40px;
        width: 40px;
        display: block;
        cursor: pointer;
        z-index: 2;
    }
    .multiselect__clear::before {
        transform: rotate(45deg);
    }
    .multiselect__clear::after {
        transform: rotate(-45deg);
    }
    .multiselect__clear::after, .multiselect__clear::before {
        content: "";
        display: block;
        position: absolute;
        width: 3px;
        height: 16px;
        background: #aaa;
        top: 12px;
        right: 4px;
    }




    .table__heading {
        height: auto !important;
        z-index: 10;
        position: relative;
        background-color: white;
    }

    .icon-sort {
        position: relative;
        margin-left: 3px;
    }

    .icon-sort::before, .icon-sort::after {
    content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0; 
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
    }

    .icon-sort::before {
        top: 20%;
        border-bottom: 5px solid #808080;
    }

    .icon-sort::after {
        top: 60%;
        border-top: 5px solid #808080;
    }

    .icon-sort.-ascending::before {
        border-bottom: 5px solid #c1006d;
    }

    .icon-sort.-descending::after {
        border-top: 5px solid #c1006d;
    }

    table.customer-following-system-table td:first-child {
        font-weight: normal;
    }
</style>
